/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OperatoreUpdateDTO
 */
export interface OperatoreUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    enteId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    cognome?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    codiceFiscale?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreUpdateDTO
     */
    cellulare?: string;
}

/**
 * Check if a given object implements the OperatoreUpdateDTO interface.
 */
export function instanceOfOperatoreUpdateDTO(value: object): value is OperatoreUpdateDTO {
    return true;
}

export function OperatoreUpdateDTOFromJSON(json: any): OperatoreUpdateDTO {
    return OperatoreUpdateDTOFromJSONTyped(json, false);
}

export function OperatoreUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatoreUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'enteId': json['enteId'] == null ? undefined : json['enteId'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'codiceFiscale': json['codiceFiscale'] == null ? undefined : json['codiceFiscale'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
    };
}

export function OperatoreUpdateDTOToJSON(value?: OperatoreUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'enteId': value['enteId'],
        'nome': value['nome'],
        'cognome': value['cognome'],
        'codiceFiscale': value['codiceFiscale'],
        'nazioneId': value['nazioneId'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
    };
}

